import styled, { css, keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

type ContainerProps = {
  $expanded?: boolean;
};

export const Container = styled.div<ContainerProps>`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.625rem 0.75rem;
    margin: 0 0.4rem;
    background: color-mix(
      in srgb,
      ${theme.colors.brand.primary.default} 7%,
      transparent
    );
    border: 1px solid
      color-mix(in srgb, ${theme.colors.brand.primary.default} 12%, transparent);
    border-radius: 0.5rem;
    cursor: pointer;
    transition: background 0.15s;
    animation: ${slideIn} 0.25s ease-out;
    flex-shrink: 0;

    &:hover {
      background: color-mix(
        in srgb,
        ${theme.colors.brand.primary.default} 7%,
        transparent
      );
    }
  `}
`;

export const PinBadge = styled.div`
  ${({ theme }) => css`
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.5rem;
    background: color-mix(
      in srgb,
      ${theme.colors.brand.primary.default} 12%,
      transparent
    );
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: ${theme.colors.brand.primary.default};

    svg {
      width: 0.875rem;
      height: 0.875rem;
    }
  `}
`;

export const Content = styled.div`
  flex: 1;
  min-width: 0;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3125rem;
  margin-bottom: 0.125rem;
`;

export const Author = styled.span`
  font-size: 0.6875rem;
  font-weight: 700;
  color: #1b2a4a;
`;

export const Tag = styled.span`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.1875rem;
    font-size: 0.5625rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${theme.colors.brand.primary.default};
    background: color-mix(
      in srgb,
      ${theme.colors.brand.primary.default} 12%,
      transparent
    );
    padding: 0.125rem 0.375rem;
    border-radius: 0.1875rem;
  `}
`;

type TextProps = {
  $expanded?: boolean;
};

export const Text = styled.div<TextProps>`
  font-size: 0.75rem;
  font-weight: 500;
  color: #3d4f6f;

  ${({ $expanded }) =>
    !$expanded &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    `}
`;

export const UnpinButton = styled.button`
  ${({ theme }) => css`
    width: 1.375rem;
    height: 1.375rem;
    border: none;
    background: transparent;
    color: #c4cfde;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: color 0.15s;
    padding: 0;

    &:hover {
      color: ${theme.colors.brand.primary.default};
    }

    svg {
      width: 0.875rem;
      height: 0.875rem;
    }
  `}
`;
